import { styled, H2 } from '@thesisedu/web/dist'
import { transparentize } from 'polished'

export const BrochureCardSmall = styled.div`
  border-radius: ${props => props.theme['@border-radius-large']};
  background: ${props => props.theme['@gray-0']};
  box-shadow: 0 4px 15px 0 ${props => transparentize(0.86, props.theme['@gray-4'])};
  position: relative;
  overflow: hidden;
`

export const HoverBrochureCardSmall = styled(BrochureCardSmall)`
  transition: background 0.5s linear, box-shadow 0.5s cubic-bezier(0.16, 1, 0.3, 1),
    transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  transform: translateY(0);
  cursor: pointer;
  &:hover,
  &:focus {
    transform: translateY(-6px);
    box-shadow: 0 12px 22px 0 ${props => transparentize(0.86, props.theme['@gray-6'])};
  }
  &:active {
    transform: translateY(1px);
    box-shadow: 0 3px 12px 0 ${props => transparentize(0.86, props.theme['@gray-6'])};
  }
`

export const BorderH2 = styled(H2)`
  padding-bottom: ${props => props.theme['@size-xs']};
  border-bottom: solid 1px ${props => props.theme['@border-color-base']};
  margin-bottom: ${props => props.theme['@size-l']} !important;
  &:not(:first-child) {
    margin-top: ${props => props.theme['@size-xl']} !important;
  }
`
